import { InjectionToken, Provider, Type } from '@angular/core';

export interface HarnessCase {
  component: Type<unknown>;
  id: string;
}

export const HARNESS_CASES = new InjectionToken<HarnessCase[]>('E2E_HARNESS_CASES');

export function provideHarnessCases(cases: HarnessCase[]): Provider {
  return { provide: HARNESS_CASES, useValue: cases };
}
